import Home from '/public/pages/home.svelte';
import Login from '/public/pages/login.svelte';
import CreateAccount from '/public/pages/create-account.svelte';
import ForgotPassword from '/public/pages/forgot-password.svelte';
import ResetPassword from '/public/pages/reset-password.svelte';
import Logout from '/public/pages/logout.svelte';
import ActivateAccount from '/public/pages/activate-account.svelte';
import TwoFASetup from '/public/pages/two-fa-setup.svelte';
import TwoFAChallenge from '/public/pages/two-fa-challenge.svelte';

const routes = [
    {
      name: '/',
      component: Home,
    },
    {
        name: 'login',
        component: Login
    },
    {
        name: 'create-account',
        component: CreateAccount
    },
    {
        name: 'forgot-my-password',
        component: ForgotPassword
    },
    {
        name: 'password-reset/:hash',
        component: ResetPassword
    },
    {
      name: 'logout',
      component: Logout
    },
    {
        name: 'activate-account/:hash',
        component: ActivateAccount
    },
    {
        name: 'two-fa-setup/:hash',
        component: TwoFASetup
    },
    {
        name: 'two-fa-challenge/:hash',
        component: TwoFAChallenge
    }
]

  export { routes }
